import React from "react";
import TeamMembersGrid from "./team-members-grid";
import PageSections from "./page-sections";
import styles from "./team-page.module.css";
import { cn } from "../lib/helpers";

const TeamPage = (props) => {
  const { pageTitle, members, _rawClosingCopy, closingCopy, _rawContent, content } = props;
  const sectionContent = _rawContent ? _rawContent : content;

  const closingCopyBlocks = _rawClosingCopy || closingCopy;
  return (
    <main className={cn(styles.root)}>
      <TeamMembersGrid title={pageTitle} members={members} closingCopy={closingCopyBlocks} />
      {sectionContent && !!sectionContent.length && (
        <PageSections content={sectionContent} isThemeDark={true} />
      )}
    </main>
  );
};

export default TeamPage;
